import { Assignment } from '@/types/models/assignment';
import axios from '@/helpers/axios';

export async function fetchAssignment(id: string) {
  return await axios.get<Assignment>(`/assignments/${id}`).then(res => res.data);
}
